var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 116,
    viewBox: "0 0 82 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 116,
    rx: 8,
    fill: "#474747"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2494 55.8302L49.8575 61.9215C50.9188 64.408 49.0976 67.1667 46.3931 67.1667H35.7598C32.9696 67.1667 31.1471 64.2219 32.4059 61.7223L33.8397 58.8465C34.3082 57.9143 35.0708 57.274 36.0004 57.1741C36.9317 57.074 37.8116 57.5396 38.4631 58.3578L38.4662 58.3616L38.6473 58.5922C39.0469 59.0905 39.452 59.223 39.7477 59.1984C40.0435 59.1738 40.4198 58.9764 40.7288 58.4198L42.3038 55.5781C42.9064 54.4925 43.8002 53.7169 44.8761 53.7718C45.9522 53.8267 46.7616 54.6893 47.2494 55.8302ZM43.6157 56.3053C44.1047 55.4246 44.5694 55.2581 44.7997 55.2699C45.0297 55.2816 45.4745 55.4942 45.8701 56.4198L48.4783 62.5111C49.1171 64.0078 48.0219 65.6667 46.3931 65.6667H35.7598C34.0838 65.6667 32.9898 63.8961 33.7461 62.396L33.7476 62.393L35.1798 59.5202L35.1804 59.5191C35.4867 58.9104 35.8697 58.6968 36.1608 58.6655C36.45 58.6344 36.8653 58.7602 37.2882 59.2904L37.47 59.5217L37.4741 59.5269C38.1073 60.3183 38.9638 60.7687 39.8718 60.6933C40.7802 60.6178 41.5496 60.0321 42.0405 59.1472L43.6157 56.3053Z",
    fill: "#858585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9097 50.5C35.9432 50.5 35.1597 51.2835 35.1597 52.25C35.1597 53.2165 35.9432 54 36.9097 54C37.8762 54 38.6597 53.2165 38.6597 52.25C38.6597 51.2835 37.8762 50.5 36.9097 50.5ZM33.6597 52.25C33.6597 50.4551 35.1148 49 36.9097 49C38.7046 49 40.1597 50.4551 40.1597 52.25C40.1597 54.0449 38.7046 55.5 36.9097 55.5C35.1148 55.5 33.6597 54.0449 33.6597 52.25Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/noImage.33c1b522cdbcde91c8f1853e6596bcb4.svg";
export { ForwardRef as ReactComponent };